import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  Typography,
  Card,
  Table,
  CardContent,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  Button,
} from '@mui/material';
import Select from 'react-select';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { SHeadTableCell } from '../../../components/styledComponents/Tables';
import Preloader from '../../../components/other/Preloader/Preloader';
import TablePaginator from '../../../components/tableComponents/TablePaginator/TablePaginator';
import { actions as transactionsActions } from '../../../store/ducks/transactions.duck';
import { actions as profileActions } from '../../../store/ducks/profile.duck';
import { IAppState } from '../../../store/rootDuck';
import { setLayoutFooter, setLayoutSubheader } from '../../../utils/layout';
import homeStyles from '../../../constants/homeStyles';
import { useStylesPromocodes } from './hooks/useStyles';
import SettingsTransactions from './components/SettingsTransactions';
import useCrudSnackbar from '../../../hooks/useCrudSnackbar';
import FillterByUser from './components/FillterByUser';
import FillterByOperator from './components/FillterByOperator';
import { useDefineUserRole } from '../../../hooks';
import { ModaAddBalance } from './components/ModaAddBalance';
import { getRequestTypeWithTranslates } from './constatns';

const TransactionPage: React.FC<TPropsFromRedux> = ({
  page,
  perPage,
  total,
  transactions,
  delTransactionSuccess,
  delTransactionError,
  clearDelTransaction,
  fetch,
  loading,
  me,
  fetchMe,
  loadingMe,
  clearMe,
  loadingTransactions,
}) => {
  const classes = useStylesPromocodes();
  const homeClasses = homeStyles();
  const [headerName, setHeaderName] = useState('');
  const intl = useIntl();
  const [changeRange, setChangeRange] = React.useState<boolean>(false);
  const [selectedDriver, setSelectedDriver] = useState<any>();
  const [selectedOperator, setSelectedOperator] = useState<any>();
  const isCashier = useDefineUserRole(me, 'ROLE_CASHIER');
  const [openModal, setOpenModal] = useState(false);
  const [selectedType, setSelectedType] = useState<string>('');
  const defaultType = { value: '', label: intl.formatMessage({ id: 'ORDER.FILTER.PLACEHOLDER' }) };
  const [startDate, setStartDate] = React.useState<string>(
    moment(new Date(2024, 0, 1, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss')
  );
  const [endDate, setEndDate] = React.useState<string>(
    moment(new Date()).format('YYYY.MM.DD HH:mm')
  );

  const selectStyles = {
    container: (provided: any) => ({
      ...provided,
      marginBottom: 16,
      width: '100%',
    }),
    menu: (provided: any, state: any) => ({
      ...provided,
      zIndex: 999,
      display: state.selectProps.isSearchable ? provided.display : 'none',
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderColor: state.isFocused ? '#ffb822' : '#6c757d',
      backgroundColor: '#ffffff',
      border: state.isFocused ? 'none !important' : '1px solid #6c757d',
      opacity: state.isFocused ? 1 : 0.5,
      boxShadow: state.isFocused ? '0 0 0 1px #ffb822 !important' : '',
      height: 55,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#ffb822' : '#fff',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: '#4c4c4c',
      fontFamily: 'Montserrat',
      fontWeight: 600,
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontFamily: 'Montserrat',
      fontWeight: 600,
    }),
    dropdownIndicator: (provided: any, state: any) => {
      return {
        ...provided,
        display: state.selectProps.isSearchable ? provided.display : 'none',
      };
    },
  };

  const translates: { [type: string]: string } = {
    manual: 'Вручную',
    sbp: 'СБП',
  };

  const transactionTypes = getRequestTypeWithTranslates(translates);

  useCrudSnackbar({
    success: delTransactionSuccess,
    error: delTransactionError,
    clear: clearDelTransaction,
    successMessage: intl.formatMessage({ id: 'COMPANY.DELETE.SUCCESS' }),
    errorMessage: `${intl.formatMessage({ id: 'ERROR' })}: ${delTransactionError}`,
    afterSuccessOrError: () => {
      clearDelTransaction();
    },
    afterSuccess: () =>
      fetch({
        page,
        perPage,
        filterData: {
          start_date: startDate,
          end_date: endDate,
          id: selectedDriver?.id || undefined,
          author_id: isCashier ? me?.id : selectedOperator.id || undefined,
          type: selectedType || undefined
        },
        isFilter: isCashier ? true : changeRange,
      }),
  });

  const handleChangeRange = (start: string | Date, end: string | Date) => {
    const first = moment(start).format('YYYY-MM-DD HH:mm');
    const second = moment(end).format('YYYY-MM-DD HH:mm');
    setChangeRange(true);
    setStartDate(first);
    setEndDate(second);
  };

  useEffect(() => {
    if (selectedDriver) {
      setChangeRange(true);
    }
  }, [selectedDriver]);

  useEffect(() => {
    fetchMe();
    return () => {
      clearMe();
    };
  }, []);

  useEffect(() => {
    setHeaderName(intl.formatMessage({ id: 'SUBMENU.TRANSACTIONS' }));
    fetch({
      page,
      perPage,
      filterData: {
        start_date: startDate,
        end_date: endDate,
        id: selectedDriver?.id || undefined,
        author_id: isCashier ? me?.id : selectedOperator?.id || undefined,
        type: selectedType || undefined
      },
      isFilter: isCashier ? true : changeRange,
    });
  }, [me, changeRange, startDate, endDate, selectedDriver, selectedOperator, isCashier, selectedType]);

  setLayoutSubheader({
    title: headerName,
    breadcrumb: [],
  });
  setLayoutFooter({ show: true });

  if (!me || loadingMe || !transactions || loading || loadingTransactions)
    return <Preloader />;
  return (
    <>
      <ModaAddBalance
        showModal={openModal}
        closeModal={() => setOpenModal(false)}
        handleSucess={() =>
          fetch({
            page: 1,
            perPage: 20,
            filterData: {
              start_date: startDate,
              end_date: endDate,
              id: selectedDriver?.id || undefined,
              author_id: isCashier ? me?.id : selectedOperator?.id || undefined,
            },
            isFilter: isCashier ? true : changeRange,
          })
        }
      />
      {(isCashier || me.is_admin) && (
        <Button
          color='primary'
          variant='contained'
          onClick={() => setOpenModal(true)}
          className={classes.addBtn}
        >
          {intl.formatMessage({ id: 'ADD.BALANCE' })}
        </Button>
      )}
      <div className={classes.container}>
        <div className={classes.filterCol}>
          <Card className={classes.filter}>
            <>
              {me.is_admin && (
                <SettingsTransactions
                  {...{
                    handleChangeRange,
                    startDate,
                    endDate,
                  }}
                />
              )}

              {me.is_admin && (
                <FillterByUser
                  {...{
                    setChangeRange,
                    selectedDriver,
                    setSelectedDriver,
                  }}
                />
              )}

              {me.is_admin && (
                <FillterByOperator
                  {...{
                    setChangeRange,
                    selectedOperator,
                    setSelectedOperator,
                  }}
                />
              )}

              {!isCashier && (
                <div style={{padding: '0 22px', marginBottom: 40}}>
                  <Typography variant='h6' className={classes.title}>
                    Тип
                  </Typography>

                  <Select
                    placeholder={intl.formatMessage({ id: 'ORDER.FILTER.PLACEHOLDER' })}
                    components={{ IndicatorSeparator: () => null }}
                    value={
                      selectedType
                        ? { label: translates[selectedType], value: selectedType }
                        : undefined
                    }
                    styles={selectStyles}
                    onChange={item => {
                      if (item) {
                        setSelectedType(item.value);
                        setChangeRange(true)
                      }
                    }}
                    options={
                      transactionTypes
                        ? [
                            defaultType,
                            ...transactionTypes.map(item => ({
                              label: item.translate,
                              value: item.type,
                            })),
                          ]
                        : [defaultType]
                    }
                  />
                </div>
              )}
              
              {me.is_admin && (
                <div className={classes.from}>
                  <Button
                    color='primary'
                    variant='contained'
                    onClick={() => {
                      setChangeRange(true);
                      setStartDate(
                        moment(new Date(2024, 0, 1, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss')
                      );
                      setEndDate(moment(new Date()).format('YYYY.MM.DD HH:mm'));
                      setSelectedDriver(null);
                      setSelectedOperator(null);
                      setSelectedType('')
                    }}
                    className={classes.addBtn}
                  >
                    Сбросить
                  </Button>
                </div>
              )}
            </>
          </Card>
        </div>
        <div className={classes.ordersCol} style={{ width: isCashier ? '100%' : '' }}>
          <Card className={classes.card}>
            <CardContent className={homeClasses.classes.tableContainer}>
              <Table aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <SHeadTableCell>
                      {intl.formatMessage({ id: 'COMPANY.TABLE.ID' })}
                    </SHeadTableCell>
                    <SHeadTableCell>
                      {intl.formatMessage({ id: 'COMPANY.TABLE.CREATED_AT' })}
                    </SHeadTableCell>
                    <SHeadTableCell>
                      {intl.formatMessage({ id: 'COMPANY.TABLE.USER' })}
                    </SHeadTableCell>
                    {!isCashier && (
                      <SHeadTableCell>
                        {intl.formatMessage({ id: 'COMPANY.TABLE.AUTHOR' })}
                      </SHeadTableCell>
                    )}
                    <SHeadTableCell>
                      {intl.formatMessage({ id: 'COMPANY.TABLE.COMMENT' })}
                    </SHeadTableCell>
                    <SHeadTableCell>
                      {intl.formatMessage({ id: 'COMPANY.TABLE.AMOUNT' })}
                    </SHeadTableCell>
                  </TableRow>
                </TableHead>
                {!transactions?.length ? (
                  <Typography className={classes.empty} component='h5' variant='h5'>
                    {intl.formatMessage({ id: 'COMMON.LIST.EMPTY' })}
                  </Typography>
                ) : (
                  <TableBody>
                    {transactions?.map((transaction: any) => {
                      const {
                        first_name: firstNameUser,
                        last_name: lastNameUser,
                        middle_name: middleNameUser,
                        fio,
                      } = transaction.user;
                      const author = transaction.author?.fio;
                      const promoCode = transaction.promo_code?.code;
                      return (
                        <>
                          <TableRow key={transaction.id}>
                            <TableCell>{transaction.id || '-'}</TableCell>
                            <TableCell>
                              {transaction.created_at
                                ? moment(transaction.created_at).format('DD.MM.YYYY HH:mm')
                                : '-'}
                            </TableCell>
                            <TableCell>
                              {!firstNameUser && !lastNameUser && !middleNameUser && !fio
                                ? '-'
                                : `${lastNameUser || ''} ${firstNameUser || ''} ${fio || ''} ${
                                    middleNameUser || ''
                                  }`}
                            </TableCell>
                            {!isCashier && <TableCell>{author}</TableCell>}
                            <TableCell>{`${transaction.comment || ''} ${
                              transaction.comment && promoCode ? ', ' : ''
                            } ${
                              promoCode
                                ? `${
                                    transaction.comment.trim() === 'promo code'
                                      ? ''
                                      : 'Promocode:'
                                  } ${promoCode}`
                                : ''
                            }`}</TableCell>
                            <TableCell>{transaction.amount || '-'}</TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                  </TableBody>
                )}
                <TableFooter>
                  <TableRow>
                    <TablePaginator
                      page={page}
                      perPage={perPage}
                      fetchRows={fetch}
                      total={total}
                      label={intl.formatMessage({ id: 'TRANSACTIONS.TABLE.TITLE' })}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

const connector = connect(
  (state: IAppState) => ({
    page: state.transactions.page,
    perPage: state.transactions.per_page,
    total: state.transactions.total,
    transactions: state.transactions.transactions,
    delTransactionSuccess: state.transactions.delTransactionSuccess,
    delTransactionError: state.transactions.delTransactionError,
    loading: state.promocodes.loading,
    me: state.profile.me,
    loadingMe: state.profile.loading,
    loadingTransactions: state.transactions.loading,
  }),
  {
    fetch: transactionsActions.fetchRequest,
    clearDelTransaction: transactionsActions.clearDelTransaction,
    fetchMe: profileActions.fetchRequest,
    clearMe: profileActions.clearMe,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(TransactionPage);
